import React, {Component} from "react";
import ScopeItem from "./ScopeItem";
import * as messageConstants from "../../../shared/messages";
import {PropTypes} from "prop-types";
import "./Claims.scss";

class Scope extends Component {
    static propTypes = {
        displayFlexibleAttributes: PropTypes.bool,
        displayUserExtendedAttributes: PropTypes.bool,
        displayNonLdapEpicUsername: PropTypes.bool,
        extendedAttributes: PropTypes.object,
        addScope: PropTypes.func,
        updateScope: PropTypes.func,
        deleteScope: PropTypes.func,
        oidcScope: PropTypes.array,
    }

    render() {
        const scopeItems = this.props.oidcScope
            ? this.props.oidcScope.map((scopeItem, index) =>
                <ScopeItem
                    oidcScopeItem={scopeItem}
                    updateScope={this.props.updateScope}
                    deleteScope={this.props.deleteScope}
                    extendedAttributes={this.props.extendedAttributes}
                    displayUserExtendedAttributes={this.props.displayUserExtendedAttributes}
                    displayFlexibleAttributes={this.props.displayFlexibleAttributes}
                    displayNonLdapEpicUsername={this.props.displayNonLdapEpicUsername}
                    id={index}
                    key={index}/>
            ) : [];

        return(
            <div className="oidc-scope-container">
                {scopeItems}
                <button type="button" onClick={this.props.addScope} className="attr-button">
                    <span className="fa fa-plus btn-circle btn-plus"/>
                    <span className="attr-button-label">{messageConstants.BUTTON_ADD_CUSTOM_SCOPE}</span>
                </button>
            </div>
        );
    }
}

export default Scope;
